import { queryOptions } from '@tanstack/react-query';

import { fetchSurveysGateway } from './fetchSurveysGateway';
import type { SurveySubject } from '../model/types';
import type { SurveysGateway } from '../ports/surveysGateway';

import { FIVE_MINUTES } from '@/constants/time';
import { userScoped } from '@/util/userScope';

/**
 * The currently published version of a survey group by slug — the app needs
 * the version-specific `id` (not the slug) to submit a response against.
 */
export function getPublishedSurveyBySlugQueryOptions(
  slug: string,
  gateway: SurveysGateway = fetchSurveysGateway
) {
  return queryOptions({
    queryKey: ['surveys', 'current', slug],
    queryFn: () => gateway.getCurrentSurvey(slug),
    // A published definition is immutable; only a new publish changes it, so a
    // long stale window avoids refetching the schema on every chat mount.
    staleTime: FIVE_MINUTES,
    gcTime: FIVE_MINUTES,
  });
}

export const getMySurveyResponsesForSubjectQueryOptions = userScoped(
  'user',
  (
    userId: string | undefined,
    subject: SurveySubject,
    gateway: SurveysGateway = fetchSurveysGateway
  ) =>
    queryOptions({
      queryKey: ['surveys', 'responses', 'me', userId, subject.type, subject.id],
      queryFn: () => gateway.listMyResponses(subject),
      staleTime: FIVE_MINUTES,
      gcTime: FIVE_MINUTES,
    })
);
